/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
import React, { Component } from 'react';
import {
  selectRating,
  selectReferralsCountStat,
  selectTasksCountStat
} from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';
import { HashLink } from 'react-router-hash-link';
import { withRouter } from 'react-router-dom';

class MyCountsStat extends Component {
  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-footer">
          <div className="hor-scroll hor-scroll_always">
            <div className="hor-scroll-wrapper">
              <a className="counter" data-toggle="scroll" href="#rating">
                <div
                  data-container="body"
                  data-placement="top"
                  data-toggle="tooltip-hover"
                  title=""
                  data-original-title={t('Мой рейтинг')}
                >
                  <div className="counter-val text-primary">
                    {this.props.rating.ratingStatusPoints}/
                    {parseFloat(this.props.rating.rating) < 100
                      ? this.props.rating.ratingStatusPointsTo
                      : this.props.rating.ratingStatusPoints}
                  </div>
                  <div className="counter-label">{t('Мой рейтинг')}</div>
                </div>
              </a>
              <a className="counter" data-toggle="scroll" href="#myStatistics">
                <div
                  data-container="body"
                  data-placement="top"
                  data-toggle="tooltip-hover"
                  title={t('Выполненные задания')}
                >
                  <div className="counter-val text-success">
                    {
                      this.props.tasksCountStat.myExecutionsStat
                        .countExecFinished
                    }
                  </div>
                  <div className="counter-label">{t('Мои выполнения')}</div>
                </div>
              </a>
              <a className="counter" data-toggle="scroll" href="#myStatistics">
                <div
                  data-container="body"
                  data-placement="top"
                  data-toggle="tooltip-hover"
                  title={t('Статистика')}
                >
                  <div className="counter-val text-info">
                    {this.props.tasksCountStat.countExecutionsMyTasks}
                  </div>
                  <div className="counter-label">
                    {t('Выполнения моих заданий')}
                  </div>
                </div>
              </a>
              <HashLink
                className="counter"
                to="/referral-program/my-stat#statMyAffiliates"
              >
                <div
                  data-container="body"
                  data-placement="top"
                  data-toggle="tooltip-hover"
                  title={t('Рефералы')}
                >
                  <div className="counter-val text-warning">
                    {this.props.referralsCountStat.count}
                  </div>
                  <div className="counter-label">{t('Рефералы')}</div>
                </div>
              </HashLink>
              <HashLink
                className="counter"
                to="/referral-program/my-stat#statAffiliateMoney"
              >
                <div
                  data-container="body"
                  data-placement="top"
                  data-toggle="tooltip-hover"
                  title={t('Заработано')}
                >
                  <div className="counter-val text-danger">
                    {this.props.referralsCountStat.earned_amount}
                  </div>
                  <div className="counter-label">{t('Заработано')}</div>
                </div>
              </HashLink>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MyCountsStat.propTypes = {
  rating: PropTypes.shape({
    rating: PropTypes.string.isRequired,
    ratingStatusPoints: PropTypes.number.isRequired,
    ratingStatusPointsTo: PropTypes.number.isRequired
  }).isRequired,
  tasksCountStat: PropTypes.shape({
    countExecutionsMyTasks: PropTypes.number.isRequired,
    myExecutionsStat: PropTypes.shape({
      countExecFinished: PropTypes.number.isRequired
    })
  }).isRequired,
  referralsCountStat: PropTypes.shape({
    count: PropTypes.number,
    earned_amount: PropTypes.string
  }).isRequired
};

const mapStateToProps = state => ({
  rating: selectRating(state),
  tasksCountStat: selectTasksCountStat(state),
  referralsCountStat: selectReferralsCountStat(state)
});

export default withRouter(connect(mapStateToProps)(MyCountsStat));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyRatingAndStat/MyCountsStat/MyCountsStat.js